import React from "react";
import { SelectBox } from "devextreme-react/select-box";

/**
 * Filters of POST Tracking: airport and transport vendor, then Search / Clear, and "Back to …" when another screen
 * opened Tracking. filters = { airportCode, transporterId }; onChange(partial).
 */
export default function TrackingFilterBar({ filters, airports, vendors, searching, sourceTitle, onChange, onSearch, onClear, onBack }) {
  return (
    <section className="dsp-filters" aria-label="Filters">
      <div className="dsp-field dsp-field--airport">
        <label>Airport</label>
        <SelectBox
          dataSource={airports}
          displayExpr="airportName"
          valueExpr="airportCode"
          value={filters.airportCode || null}
          placeholder="All airports"
          showClearButton
          searchEnabled
          inputAttr={{ "aria-label": "Airport" }}
          onValueChanged={(e) => onChange({ airportCode: e.value ?? "" })}
        />
      </div>
      <div className="dsp-field dsp-field--airport">
        <label>Transport vendor</label>
        <SelectBox
          dataSource={vendors}
          displayExpr="name"
          valueExpr="id"
          value={filters.transporterId || null}
          placeholder="All vendors"
          showClearButton
          searchEnabled
          inputAttr={{ "aria-label": "Transport vendor" }}
          onValueChanged={(e) => onChange({ transporterId: e.value ?? 0 })}
        />
      </div>
      <div className="dsp-field dsp-field--action trk-actions">
        {onBack && (
          <button type="button" className="btn btn-outline-primary btn-sm" title={`Back to ${sourceTitle}`} onClick={onBack}>
            <i className="fas fa-arrow-left" aria-hidden="true" /> Back to {sourceTitle}
          </button>
        )}
        <button type="button" className="btn btn-secondary btn-sm" disabled={searching} onClick={onClear}>
          Clear
        </button>
        <button type="button" className="btn btn-primary btn-sm dsp-search" disabled={searching} onClick={onSearch}>
          <i className={`fas fa-${searching ? "spinner fa-spin" : "search"}`} aria-hidden="true" /> Search
        </button>
      </div>
    </section>
  );
}
